export default "__VITE_ASSET__DJ2RKHlG__"